var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.476V11.1344C1 6.5927 1 4.32185 2.46446 2.91093C3.92894 1.5 6.28595 1.5 11 1.5C15.714 1.5 18.0711 1.5 19.5355 2.91093C21 4.32185 21 6.5927 21 11.1344V21.476C21 24.3584 21 25.7995 20.034 26.3154C18.1631 27.3143 14.654 23.9815 12.9875 22.978C12.021 22.396 11.5378 22.105 11 22.105C10.4622 22.105 9.979 22.396 9.0125 22.978C7.346 23.9815 3.83684 27.3143 1.96606 26.3154C1 25.7995 1 24.3584 1 21.476Z",
    stroke: "#0464B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.0af7cd73d4fd3753257a1c8fc16200ad.svg";
export { ForwardRef as ReactComponent };